import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserSessionInfo } from '@fusang/sso-client'
import SignUpForm from '../signup/SignUpForm'
import { FullContent } from '../../../../layout/authentication-layout'
import { FusangHeader } from '../../../../components'
import { redirectBack } from '../../actions'
import { SETUP_MFA_SUCCESS } from '../../action-type'

const AuthenticationForm = () => {
  const dispatch = useDispatch()
  const { iframeState } = useSelector((state) => state.auth)
  const [isLoading, setIsLoading] = useState(true)
  const [isLoggedIn, setLoggedIn] = useState(false)

  console.log('isLoggedIn', isLoggedIn)

  useEffect(() => {
    (async () => {
      try {
        const userSession = await getUserSessionInfo()
        if (userSession) {
          setLoggedIn(true)
        }
      } finally {
        setIsLoading(false)
      }
    })()
  }, [])

  if (isLoggedIn) {
    window.location = `${window.envConfiguration.REACT_APP_OIDC_BASE_URL}?error=40303:user:register`
    return null
  }

  if (isLoading) {
    return null
  }

  const onIframeLoadFinished = () => {
    const initRedirect = sessionStorage.getItem('redirectLink')
    console.log('Iframe redirect onload finish at: ', new Date(), initRedirect)
    dispatch(redirectBack(initRedirect, SETUP_MFA_SUCCESS))
  }

  return (
    <>
      <FullContent>
        <FusangHeader showCloseBtn={false} />
        <SignUpForm />
      </FullContent>
      {iframeState.showing ? (
        <div style={{ height: 0, width: 0 }}>
          <iframe
            frameBorder={0}
            height={0}
            src={iframeState.src}
            title='redirect'
            width={0}
            onLoad={onIframeLoadFinished}
          />
        </div>
      ) : null}
    </>
  )
}

export default AuthenticationForm
